import React from "react";
import { Link } from 'react-router-dom'

import Container from '../../components/Container'
import Hero from '../../components/Hero'
import Header from '../../components/Header/brandbook'
import Section from '../../components/Section'
import Icon from '../../components/Icon'
import IconDemo from '../../components/IconDemo'
import Grid from '../../components/Grid'

export const path = '/brandbook/tone-of-voice'

export default function BrandbookPage() {
  return (
    <div className="light">
      <Header />
      <Hero>
        <Container size="large">

          <Grid grid="1-2">
            <></>
            <>
              <h1><span className="highlight">Tools and Rules</span> <br />Tone of voice</h1>
            </>
          </Grid>
        </Container>

      </Hero>
      <Container size="large">

        <Section>

            <Grid grid="1-2">
              <></>
              <>
            <h2> The way we speak </h2>
            <p> Every word matters. The words we decide to use adds up to people's perception of who we are.
            We adjust our tone to the time and place, making sure we understand our audience's mood.</p>

            <h2>Our style </h2>
            <h3>Direct</h3>
            <p>
              Waved speaks concisely and directly, without any unnecessary noise.
            </p>
            <h3>Friendly</h3>
            <p>
              Waved has a friendly tone of voice, that’s always understanding and patient.
            </p>
            <h3>Helpful</h3>
            <p>Waved wants others to succeed, and makes sure people understand what they need.</p>
            </>
            </Grid>
          </Section>
          <Section>
          <Grid grid="1-2">
            <></>
            <>

            <h2>Words and phrases</h2>
            <p>We speak simple English, and use words that our customers and partners understand.</p>

            <table>
            <tr>
            <th>Waved would say ... </th>
            <th>... instead of </th>
            </tr>
            <tr>
            <td>
            Measure
            </td>
            <td>
            Capture
            </td>
            </tr>
            <tr>
            <td>
            Ideal
            </td>
            <td>
            Optimal
            </td>
            </tr>
            <tr>
            <td>
            Place
            </td>
            <td>
            Venue
            </td>
            </tr>
            <tr>
            <td>
            Give
            </td>
            <td>
            Provide
            </td>
            </tr>
            <tr>
            <td>
            Get
            </td>
            <td>
            Obtain
            </td>
            </tr>
            <tr>
            <td>
            Adjust
            </td>
            <td>
            Calculate
            </td>
            </tr>
            </table>
            <h3>Test the text </h3>
            <p>The best test is to read a text out loud.
            Listen to check if it sounds like something we would say.</p>
            </>
            </Grid>
          </Section>
          <Section>
          <Grid grid="1-2">
            <></>
            <>
            <h2>Longer texts</h2>

            <Grid>
              <>
                <h3>Waved would say ... </h3>
                <p>
                  Waved measure the energy and mood at your place. Decide the tunes you want to play,
                  while Waved adjust and fine-tune the ideal volume for each zone and mood.
                </p>
              </>
              <>
                <h3> ... instead of </h3>
                <p>
                  Sensors are strategically placed in your venue. These capture the energy
                  level and mood of the guests and continuously calculate the optimal music
                  volume in each zone. Waved connects to the existing sound system so
                  you can play music as usual.
                </p>
              </>
            </Grid>

            <Grid>
              <>
                <h3>Waved would say ... </h3>
                <p>
                  Check the mood in real-time, or see how it was last night. Waved can help
                  you stay within the approved limits, to make sure both your guests and neighbours are happy.
                </p>
              </>
              <>
                <h3> ... instead of </h3>
                <p>
                  The Waved application gives you insight into the guests' mood both in real time
                  and historically - right in your browser. You can also get noise reports that
                  can be used to show that you follow the noise level rules.
                </p>
              </>
            </Grid>
            </>
          </Grid>
      </Section>
    <br />
    </Container>
    </div>
    )
  }
